import React from "react";

import { connect } from "react-redux";
import {
    reset,
    list,
    createInvoices,
    isLoading,
    isLoaded,
    getMeta,
    getList,
    getError,
    isSecondaryLoading,
    getSecondarySuccess,
} from "../../../../../redux/actions/manager/invoice/form";

import {
    loadCache as loadCacheOld,
    isCacheLoading as isCacheLoadingOld,
    isCacheLoaded as isCacheLoadedOld,
    getProjectsForSelect,
    getPointOfSalesForSelect,
} from "../../../../../redux/actions/cache";

import {
    CACHE_VENDOR,
    CACHE_CLIENT,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getClientsById,
    getVendorsForSelect,
    getClientsForSelect,
} from "../../../../../redux/actions/cache/interface";

import {
    encodeQueryToURL,
    decodeQueryFromURL,
    onTableChangeUpdateUrl,
    onFilterChangeUpdateUrl,
} from "../../../../../core/utils/list";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../../../core/utils/form";

import FullList from "../../../../../core/components/listPattern/list";
import { PageHeader, Divider } from "antd";

import { basicColumns } from "./fields";
import Filters from "./filters";
import Form from "./form";
import Moment from "moment";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    constructor(props) {
        super(props);
        const defaultValues = {};
        const defaultHidden = [];
        defaultHidden["u.active"] = 1;
        this.state = { defaultValues, resize: [], hidden: defaultHidden };
    }

    componentDidMount() {
        const query = decodeQueryFromURL(this.props.history, this.state.defaultValues);

        const queryParams = { query };

        this.props.loadCache();
        this.props.loadCacheOld();
        this.props.list(query);
    }

    componentDidUpdate(prevProps) {
        const { history } = this.props;

        if (history.location.search != prevProps.location.search) {
            const query = decodeQueryFromURL(history, this.state.defaultValues);

            this.props.list(query);
        }
    }

    /**
     * Función que maneja el submit del formulario
     *
     * Recordar que se puede tratar de un alta o una edición
     */
    generateCPO = (values, bag) => {
        const { history } = this.props;

        const date = values.date == null ? null : Moment(values.date).format("YYYY-MM-DD");
        const form = {
            ...values,
            date: date,
        };
        const query = decodeQueryFromURL(history, this.state.defaultValues);

        const ret = this.props.createInvoices(form, query);

        ret.then((response) => {
            bag.setSubmitting(false);
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
            } else {
                if (this.props.formSuccess) {
                    this._goBack();
                    //this.props.history.push(LAYOUT_FINANCE_PURCHASE_ORDER_CLIENT_SHOW(response));
                    //this._goBack();
                    return;
                }
            }
        }).catch((e) => {
            bag.setSubmitting(false);
            alert("Se ha producido un error desconocido");
        });
    };

    componentWillUnmount() {
        this.props.reset();
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    _setColumns = (cols) => {
        this.setState({ columns: cols });
    };

    _onResize = (col, index) => (e, { size }) => {
        const nextResize = [...this.state.resize];
        nextResize[col] = size.width;
        this.setState({ resize: nextResize });
    };

    _onToggleVisible = (col) => {
        const nextHidden = this.state.hidden;
        const value = nextHidden[col] ? nextHidden[col] : 0;
        nextHidden[col] = value == 0 ? 1 : 0;
        this.setState({ hidden: nextHidden });
    };

    _onFilterChangeUpdateUrl = (form) => onFilterChangeUpdateUrl(this.props.history, form);
    _onTableChangeUpdateUrl = (pagination, filters, sorter) =>
        onTableChangeUpdateUrl(this.props.history, pagination, filters, sorter);

    render() {
        const parameters = decodeQueryFromURL(this.props.history, this.state.defaultValues);
        const columns = basicColumns({
            ...this.props,
            filters: parameters,
            resize: this.state.resize,
            hidden: this.state.hidden,
        });
        return (
            <>
                <PageHeader onBack={this._goBack} ghost={false} title="INVOICE" subTitle="Generate">
                    <Form handleSubmit={this.generateCPO} />
                </PageHeader>
                <Divider />
                <FullList
                    {...this.props}
                    titulo={"UNCOMPENSATED"}
                    subtitulo="Jobs"
                    onSearchByText={(text) => this._onFilterChangeUpdateUrl({ text })}
                    resize
                    columns={columns}
                    onResize={this._onResize}
                    onToggleVisible={this._onToggleVisible}
                    setColumns={this._setColumns}
                    filters={parameters}
                    onUpdateFilters={this._onFilterChangeUpdateUrl}
                    handleTableChange={this._onTableChangeUpdateUrl}
                >
                    <Filters filters={parameters} onUpdateFilters={this._onFilterChangeUpdateUrl} {...this.props} />
                </FullList>
            </>
        );
    }
}
const cacheList = [CACHE_VENDOR, CACHE_CLIENT];

function MapStateToProps(state) {
    return {
        meta: getMeta(state),
        data: getList(state),

        loading: isLoading(state) || isCacheLoading(state, cacheList) || isCacheLoadingOld(state),
        loaded: isLoaded(state) && isCacheLoaded(state, cacheList) && isCacheLoadedOld(state),

        formLoading: isSecondaryLoading(state),
        formSuccess: getSecondarySuccess(state),

        actionLoading: isSecondaryLoading(state),
        error: getError(state),

        vendors: getVendorsForSelect(state),
        clients: getClientsForSelect(state),
        projects: getProjectsForSelect(state),
        pointsOfSale: getPointOfSalesForSelect(state),

        clientsById: getClientsById(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),
        loadCacheOld: () => loadCacheOld(["l3", "l4"])(dispatch),
        createInvoices: (form, query) => dispatch(createInvoices(form, query)),
        list: (query) => dispatch(list(query)),
        reset: () => dispatch(reset()),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
